const elements = [
    {
        left: 287,
        top: 270,
        className: 'io1',
        imgWidth: 47,
        imgHeight: 47,
        imgSource: 'io1.svg'
    },
    {
        left: 357,
        top: 203,
        className: 'io2',
        imgWidth: 65,
        imgHeight: 113,
        imgSource: 'io2.svg'
    },
    {
        left: 353,
        top: 112,
        className: 'io4',
        imgWidth: 74,
        imgHeight: 74,
        imgSource: 'io4.svg'
    },
    {
        left: 452,
        top: 110,
        className: 'io3',
        imgWidth: 208,
        imgHeight: 208,
        imgSource: 'io3.svg'
    },
    {
        left: 100,
        top: 288,
        className: 'sq4',
        imgWidth: 282,
        imgHeight: 282,
        imgSource: 'sq4.svg'
    },
    {
        left: 138,
        top: 458,
        className: 'sq3',
        imgWidth: 206,
        imgHeight: 87,
        imgSource: 'sq3.svg'
    },
    {
        left: 170,
        top: 368,
        className: 'sq2',
        imgWidth: 42,
        imgHeight: 69,
        imgSource: 'sq2.svg'
    },
    {
        left: 271,
        top: 368,
        className: 'sq1',
        imgWidth: 42,
        imgHeight: 69,
        imgSource: 'sq1.svg'
    },
    {
        left: 337,
        top: 568,
        className: 'bwr2',
        imgWidth: 115,
        imgHeight: 100,
        imgSource: 'bwr2.svg'
    },
    {
        left: 365,
        top: 418,
        className: 'bwr5',
        imgWidth: 167,
        imgHeight: 188,
        imgSource: 'bwr5.svg'
    },
    {
        left: 312,
        top: 481,
        className: 'bwr3',
        imgWidth: 109,
        imgHeight: 109,
        imgSource: 'bwr3.svg'
    },
    {
        left: 445,
        top: 521,
        className: 'bwr1',
        imgWidth: 130,
        imgHeight: 141,
        imgSource: 'bwr1.svg'
    },
    {
        left: 487,
        top: 442,
        className: 'bwr4',
        imgWidth: 103,
        imgHeight: 102,
        imgSource: 'bwr4.svg'
    },
    {
        left: 40,
        top: 40,
        className: 'kc1',
        imgWidth: 103,
        imgHeight: 22,
        imgSource: 'kc1.svg'
    },
    {
        left: 78,
        top: 43,
        className: 'kc2',
        imgWidth: 21,
        imgHeight: 254,
        imgSource: 'kc2.svg'
    },
    {
        left: 186,
        top: 40,
        className: 'kc3',
        imgWidth: 76,
        imgHeight: 22,
        imgSource: 'kc3.svg'
    },
    {
        left: 78,
        top: 44,
        className: 'kc4',
        imgWidth: 165,
        imgHeight: 171,
        imgSource: 'kc4.svg'
    },
    {
        left: 130,
        top: 137,
        className: 'kc5',
        imgWidth: 114,
        imgHeight: 160,
        imgSource: 'kc5.svg'
    },
    {
        left: 194,
        top: 279,
        className: 'kc7',
        imgWidth: 85,
        imgHeight: 20,
        imgSource: 'kc7.svg'
    },
    {
        left: 40,
        top: 279,
        className: 'kc6',
        imgWidth: 104,
        imgHeight: 20,
        imgSource: 'kc6.svg'
    },
];

export default elements;